module.exports = __webpack_public_path__ + "img/eraser-fill.ec89feba.svg";